"use strict";
/** state: Final **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var trackMetric_1 = require("../../metrics/trackMetric");
var Fieldset_1 = require("../Fieldset");
var Input_1 = require("../Input");
var CLASS_NAME = 'i-toggle';
var Toggle = function (_a) {
    var className = _a.className, disabled = _a.disabled, id = _a.id, labelFalse = _a.labelFalse, labelTrue = _a.labelTrue, legend = _a.legend, legendHidden = _a.legendHidden, metricOptions = _a.metricOptions, name = _a.name, onChange = _a.onChange, readOnly = _a.readOnly, toggled = _a.toggled, restProps = __rest(_a, ["className", "disabled", "id", "labelFalse", "labelTrue", "legend", "legendHidden", "metricOptions", "name", "onChange", "readOnly", "toggled"]);
    var _b;
    var classes = classNames(CLASS_NAME, (_b = {}, _b[CLASS_NAME + "--disabled"] = disabled, _b), className);
    var inputClasses = classNames('sr-only', CLASS_NAME + "__input");
    var valueTrue = true;
    var valueFalse = false;
    var input = function (value) { return (React.createElement("input", { type: "radio", className: inputClasses, name: name || id, id: id + "-" + value, checked: !!toggled === value, value: String(value), disabled: disabled, onChange: trackMetric_1.trackMetric(metricOptions, function () { return !disabled && onChange && onChange(!toggled); }) })); };
    return (React.createElement(Fieldset_1.Fieldset, __assign({ className: classes, legend: legend, legendHidden: legendHidden, legendId: id + "-legend" }, restProps), readOnly ? (React.createElement(Input_1.Input, { type: Input_1.Input.Type.Text, id: id, name: name, readOnly: true, value: toggled ? labelTrue : labelFalse })) : (React.createElement("div", { role: "radiogroup", "aria-labelledby": id + "-legend" },
        input(valueTrue),
        React.createElement("label", { htmlFor: id + "-" + valueTrue }, labelTrue),
        input(valueFalse),
        React.createElement("label", { htmlFor: id + "-" + valueFalse }, labelFalse),
        React.createElement("div", { className: CLASS_NAME + "__slider" })))));
};
exports.Toggle = Toggle;
//# sourceMappingURL=Toggle.js.map